import React from  'react';
import ResetPasswordForm from '../../../smart/forms/login/ResetPasswordForm';

const ResetPasswordPage = (props) => {
    return(
        <ResetPasswordForm data={props}/>
    )
}

export default ResetPasswordPage
